enum SpecialtyGroupExceptionReviewStatusFilterOption {
  All = "all",
  None = "none",
  NotReady = "notReady",
  ReadyForReview = "readyForReview",
  ReadyForSubmission = "readyForSubmission",
}

const SpecialtyGroupExceptionReviewStatusFilterOptionLabels: Record<SpecialtyGroupExceptionReviewStatusFilterOption, string> = {
  [SpecialtyGroupExceptionReviewStatusFilterOption.All]: "All",
  [SpecialtyGroupExceptionReviewStatusFilterOption.None]: "---",
  [SpecialtyGroupExceptionReviewStatusFilterOption.NotReady]: "Not Ready",
  [SpecialtyGroupExceptionReviewStatusFilterOption.ReadyForReview]: "Ready for Review",
  [SpecialtyGroupExceptionReviewStatusFilterOption.ReadyForSubmission]: "Ready for Submission",
};

export { SpecialtyGroupExceptionReviewStatusFilterOption, SpecialtyGroupExceptionReviewStatusFilterOptionLabels };
